import React, { cloneElement } from "react";

export function Field({ className, children, label, id, required }) {
  const _label = required ? `${label} *` : label;
  const childrenWithId = cloneElement(children, {
    id,
    required,
    placeholder: _label,
  });

  return (
    <div {...{ className }}>
      <div className="pb2">{childrenWithId}</div>
    </div>
  );
}

export default Field;
